module.exports = __webpack_public_path__ + "img/0Q3A3494_L_BlackMatted_MockedUp.a32fe8d3.jpg";